module.exports = {"TXTACL_Close":{"id":"TXTACL_Close","defaultMessage":"Stäng","flags":["TRACK"],"track":"Close"}}